var map = {
	"./0b0545ba-18c2-47f6-a00f-fe0fe0b9320b.json": [
		5891,
		891
	],
	"./7f90f685-1a89-40ef-9964-71bc12d0f008.json": [
		2130,
		130
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2147;
module.exports = webpackAsyncContext;